"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./style.scss");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var meterActions = require("@caddigital/sok-reducers/lib/actions/sokosite/current");
var mapStateToProps = function (state, ownProps) {
    return {
        trmvrMeter: state.sokosite.current.trmvrMeter
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchCurrentMeter: function (id) {
        return dispatch(meterActions.fetchRequest(id, true));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchCurrentMeter(this.props.match.params.id);
    }
}), recompose_1.pure);
var component = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: 'trmvrmeter-view' },
        React.createElement("div", null, "TRMVRMeter")))); };
exports.default = enhance(component);
